
import FornecedorView from "./view/forn.list"

export const FornecedorList = FornecedorView